var DynamicArticleRoutingController = function ($scope, $rootScope) {
    $scope.holi = "Hello World";
    $scope.isAuthenticated = false;

    if ($rootScope.hasOwnProperty("css")) {
        if ($rootScope.css.accu !== "not-initialized") {
            $scope.isAuthenticated = true;
        }
    }

    $rootScope.$watch("css.accu", function (newValue, oldValue) {
        if (newValue != oldValue) {
            if (newValue !== "not-initialized") {
                $scope.isAuthenticated = true;
            }
        }
    });
};

DynamicArticleRoutingController.$inject = ["$scope", "$rootScope"];
export default DynamicArticleRoutingController;
